module.exports = __webpack_public_path__ + "static/media/builtinv2-visverlivanie.c27f45e7.png";